// extracted by mini-css-extract-plugin
export default {"tasks":"qN-z","task":"rN-z","svg":"sN-z","text":"tN-z"};